type Props = {
  /** The id the section is labelled by, in place of its heading's. */
  headingId: string;
};

/**
 * "Personalized postcards, mailed for you" — what a section of postcards opens on, in
 * place of its heading.
 *
 * A port of the legacy `mega_sale/categories/postcards.js` (since retired), which
 * `categories.js` drew instead of a section's heading whenever the section's first
 * product was a postcard: the postcards sale, and the Postcards section that closes each
 * year's Holiday Gift Guide. It is the only thing on the page that says the card is
 * printed, stamped and mailed for you, and that the message and the date are chosen at
 * checkout — the tile has nothing to choose, so without this the page never says so.
 *
 * Copy and icon are the legacy ones exactly. What is new is the layout: the heading is
 * drawn the way the section headings are, so it still reads as this section's heading,
 * but it does not stick. It is a paragraph of explanation rather than a label to keep in
 * view, and legacy's did not stick either.
 */
export default function PostcardsPromo({ headingId }: Props) {
  return (
    <div className="flex items-center gap-4 py-4 px-3 border-b border-slate-100">
      <img
        src="/resources/main/images/postcards-icon.svg"
        alt=""
        width={94}
        height={80}
        className="shrink-0 w-auto h-14 md:h-20"
      />
      <div className="min-w-0">
        <h2 id={headingId} className="m-0 text-lg font-semibold text-slate-900">
          Personalized postcards, mailed for you
        </h2>
        <p className="m-0 mt-1 text-sm text-slate-600">
          Send a real postcard - without leaving your house. 1) Pick a design &amp; add to cart 2) Customize a
          message and delivery date during checkout. That&apos;s it! We&apos;ll print, stamp, and mail it for you.
        </p>
      </div>
    </div>
  );
}
